import React from 'react';

interface RichTextProps {
  text: string;
}

export default function RichText({ text }: RichTextProps) {
  if (!text) return null;

  // Regular expression to identify URLs
  const urlRegex =
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;

  const linkifyText = (inputText: string) => {
    return inputText.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            className='text-primary-filled-default underline'
            target='_blank'
            rel='noopener noreferrer'
          >
            {part}
          </a>
        );
      } else {
        return part;
      }
    });
  };

  const lines = text.split('\n');

  return (
    <div>
      {lines.map((line, index) => (
        <React.Fragment key={index}>
          {line === '' ? <br /> : <p>{linkifyText(line)}</p>}
        </React.Fragment>
      ))}
    </div>
  );
}
